import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import Token from '@/config/token';
import eitsApi from '@/apis/eitsApi';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    _classCallCheck(this, Index);

    return _super.apply(this, arguments);
  }

  _createClass(Index, [{
    key: "closeDialog",
    value: function closeDialog() {}
  }, {
    key: "changeBack",
    value: function changeBack(payload) {
      var _this = this;

      if (payload.type === 'success') {
        this.$store.dispatch('ClearLoginInfo', this.$store.getters.userInfo.userName).then(function () {
          _this.$router.push('/login'); // this.$message.success('密码修改成功,请重新登录');

        });
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      this.eitsModPwd.beforeMod();
    }
  }, {
    key: "userName",
    get: function get() {
      return this.$store.getters.userInfo.userName;
    }
  }, {
    key: "token",
    get: function get() {
      return Token.getToken();
    }
  }, {
    key: "productCode",
    get: function get() {
      return this.$store.getters.userInfo.productCode;
    }
  }, {
    key: "changePwdUrl",
    get: function get() {
      return eitsApi.UPDATE_PWD_SDK;
    }
  }, {
    key: "challengeCodeUrl",
    get: function get() {
      return eitsApi.CHALLENGE_CODE_SDK;
    }
  }]);

  return Index;
}(Vue);

__decorate([Prop({
  required: true,
  default: false
})], Index.prototype, "pwdDialogVisible", void 0);

__decorate([Emit('closeDialog')], Index.prototype, "closeDialog", null);

__decorate([Ref('eitsModPwd')], Index.prototype, "eitsModPwd", void 0);

Index = __decorate([Component], Index);
export default Index;